// Ensure polyfill compatibility between create-react-app and zero-config nwb apps.
// This is from https://github.com/facebookincubator/create-react-app/blob/master/config/polyfills.js

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behaviour.
  require('promise/lib/rejection-tracking').enable()
  window.Promise = require('promise/lib/es6-extensions.js')
}

// fetch() polyfill for making API calls
require('whatwg-fetch')

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign')



//////////////////
// WEBPACK FOOTER
// ./~/nwb/polyfills.js
// module id = +prg
// module chunks = 0